var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0742 10.4179H12.7097L16.4774 3.78895C16.5706 3.62567 16.5701 3.42531 16.4759 3.26257C16.3811 3.09998 16.2075 3 16.0195 3H9.6914C9.4644 3 9.26294 3.14529 9.19139 3.36049L6.02734 12.8878C5.97323 13.0485 6.00056 13.2256 6.09943 13.3631C6.19886 13.5007 6.35802 13.582 6.52735 13.582H11.0011L8.15222 20.2651C8.05019 20.5025 8.13574 20.7791 8.3541 20.9175C8.56888 21.0549 8.85741 21.0188 9.03071 20.8229L17.4682 11.2956C17.6062 11.1406 17.6403 10.9185 17.5553 10.7295C17.4702 10.54 17.2818 10.4179 17.0742 10.4179Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt2);
export default __webpack_public_path__ + "static/media/Bolt2.bd7719a5aefda73dd07ddcab882595ed.svg";
export { ForwardRef as ReactComponent };